import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    children: [{
      name: 'Home',
      path: '/',
      component: () => import(/* webpackChunkName: "sig" */ '../views/lemApp/Sig')
    },
    {
      name: 'scada',
      path: '/scada',
      component: () => import(/* webpackChunkName: "scada" */ '../views/lemApp/Scada')
    },
    {
      name: 'canales',
      path: '/canales',
      component: () => import(/* webpackChunkName: "canales" */ '../views/lemApp/Canales')
    },
    {
      name: 'pozos',
      path: '/pozos',
      component: () => import(/* webpackChunkName: "pozos" */ '../views/lemApp/Pozos')
    }]
  },


  {
    name: 'about',
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About')
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "noFound" */ '../views/NotFound')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  routes
})

export default router
